<template>
  <article class="flex flex-col">
    <div v-if="isVideoState || isRegularState" class="mb-[64px]">
      <div v-if="isVideoState" class="w-full">
        <iframe
          v-lazy-load
          :src="data.video_code"
          width="100%"
          class="h-[675px]"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>

      <div v-else class="flex w-1/3">
        <img
          v-lazy-load
          :src="data?.image.preview"
          :alt="data?.image.alt || data?.title"
          class="w-full object-cover"
        />
      </div>
    </div>
    <h2 class="mb-[28px] text-[24px] font-medium">
      {{ digits(index + 1) }}. {{ data.title }}
    </h2>
    <div v-if="data.body" class="text-[18px]" v-html="data.body" />
    <AudioBar
      v-if="isAudioState"
      class="mb-[24px]"
      :file-path="data.path"
      :course="course"
      @start-play="emit('start-play')"
      @end-play="emit('end-play')"
    />
    <CommonBlocksNewTagsBlock
      v-if="isVideoState && data.tags"
      class="mt-[65px]"
      :tags="data.tags"
    />
  </article>
</template>

<script setup>
import { digits } from '@/services/helpers';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },

  index: {
    type: Number,
    default: 0,
  },

  state: {
    type: String,
    default: 'regular',
    validate: (value) => ['regular', 'audio', 'video'].includes(value),
  },

  course: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['start-play', 'end-play']);

// const getCardSettings = useCardSettings();

// const getDataByModel = computed(() => {
//   return getCardSettings(props.data);
// });

const isRegularState = computed(() => {
  return props.state === 'regular' && props.data?.image;
});

const isAudioState = computed(() => {
  return props.state === 'audio';
});

const isVideoState = computed(() => {
  return props.state === 'video' && props.data?.video_code;
});
</script>
